
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'

// @types
import { TariffExpress } from '@/new-services/types/express'

// classes
import { DataState } from '@/core/classes/DataState.class'

// constants
import { ExpressTariffsColumns } from '@/core/constants/columns/ExpressOrder.columns'

// @new-services
import expressAPI from '@/new-services/express.service'

const WITH_TENGE = ['pricePerServing', 'pricePerKilometer', 'pricePerDelivery']

export default defineComponent({
    components: {
        PageTitle,
        FailedFetch,
        TheTable,
        TableScrollWrapper,
    },
    setup() {
        const state = reactive(new DataState<TariffExpress>({}))

        const loadTariffs = async (page: number) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true
                const data = await expressAPI.getList(page)

                state.list = data.data.data

                state.pagination.total_pages = data.data.meta.last_page
                state.pagination.total_items = data.data.meta.total

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        //

        onBeforeMount(() => loadTariffs(1))

        //

        return {
            state,
            //
            loadTariffs,
            //
            ExpressTariffsColumns,
            WITH_TENGE,
        }
    },
})
